import { MapPin, Clock, Phone, Mail, MessageCircle, Instagram } from "lucide-react";
import { ADDRESS, HOURS, EMAIL, PHONE, telLink, waLink, MAP_URL, INSTAGRAM_DEFAULT } from "../../lib/site";

export default function Footer({ instagramUrl }) {
  const ig = instagramUrl || INSTAGRAM_DEFAULT;
  return (
    <footer id="contact" className="relative border-t border-white/10 bg-ink">
      <div className="mx-auto max-w-[1400px] px-5 py-16 md:px-10 md:py-24">
        <h2 className="font-heading text-[15vw] font-black uppercase leading-[0.85] tracking-tighter text-white md:text-[10vw]">
          Rent A Car<span className="text-volt">.</span>
        </h2>
        <p className="mt-2 font-heading text-[15vw] font-black uppercase leading-[0.85] tracking-tighter text-white/20 md:text-[10vw]">
          Kohima
        </p>

        <div className="mt-16 grid grid-cols-1 gap-10 border-t border-white/10 pt-12 md:grid-cols-4">
          <div>
            <div className="mb-3 flex items-center gap-2 text-volt"><MapPin size={16} /><span className="text-xs font-bold uppercase tracking-[0.2em]">Location</span></div>
            <p className="text-sm leading-relaxed text-white/70">{ADDRESS}</p>
            <a href={MAP_URL} target="_blank" rel="noreferrer" data-testid="footer-map-link" className="mt-3 inline-block text-xs font-bold uppercase tracking-wider text-volt hover:underline">
              Open in Google Maps →
            </a>
          </div>
          <div>
            <div className="mb-3 flex items-center gap-2 text-volt"><Clock size={16} /><span className="text-xs font-bold uppercase tracking-[0.2em]">Hours</span></div>
            <p className="text-sm leading-relaxed text-white/70">{HOURS}</p>
          </div>
          <div>
            <div className="mb-3 flex items-center gap-2 text-volt"><Phone size={16} /><span className="text-xs font-bold uppercase tracking-[0.2em]">Contact</span></div>
            <a href={telLink} data-testid="footer-phone" className="block text-sm text-white/70 hover:text-volt">{PHONE}</a>
            <a href={waLink()} target="_blank" rel="noreferrer" data-testid="footer-whatsapp" className="mt-1 inline-flex items-center gap-1.5 text-sm text-white/70 hover:text-volt">
              <MessageCircle size={13} /> WhatsApp
            </a>
            <a href={`mailto:${EMAIL}`} data-testid="footer-email" className="mt-1 flex items-center gap-1.5 text-sm text-white/70 hover:text-volt">
              <Mail size={13} /> {EMAIL}
            </a>
            <a href={ig} target="_blank" rel="noreferrer" data-testid="footer-instagram" className="mt-1 flex items-center gap-1.5 text-sm text-white/70 hover:text-volt">
              <Instagram size={13} /> @rentabikekohima
            </a>
          </div>
          <div>
            <div className="mb-3 overflow-hidden border border-white/10">
              <iframe
                title="Rent A Car Kohima location"
                src="https://www.google.com/maps?q=Kohima,Nagaland&output=embed"
                className="h-40 w-full grayscale"
                loading="lazy"
              />
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-white/10 pt-8 text-xs text-white/40 md:flex-row md:items-center md:justify-between">
          <p className="max-w-2xl">
            Disclaimer: All bookings are finalized in person / over direct communication. No online payments are processed on this website.
          </p>
          <div className="flex items-center gap-4">
            <span>© {new Date().getFullYear()} Rent A Car Kohima</span>
            <a href="/admin" data-testid="footer-admin-link" className="text-white/30 hover:text-volt">Admin</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
